import { render } from "./TopBar.vue?vue&type=template&id=3407dc14&scoped=true"
const script = {}

import "./TopBar.vue?vue&type=style&index=0&id=3407dc14&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3407dc14"]])

export default __exports__